import type { Contact } from '@weft/types';
import type { NonEmptyArray } from '@weft/utils';
import { isNotNullOrUndefined } from '@weft/utils';

export function getPrimaryContact(contacts: NonEmptyArray<Contact>): Contact {
  const primaryContact = contacts.find(contact => contact.isPrimary);
  const [firstContact] = contacts;

  return isNotNullOrUndefined(primaryContact) ? primaryContact : firstContact;
}